import { ColumnResizingContextProvider } from 'src/contexts/ColumnResizingContext/ColumnResizingContext';
import { Content } from 'src/contexts/ContentContext';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { vars } from 'src/core/themes';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { NoData } from 'src/tables/Table';
import { Table } from 'src/tables/TableV2/Table';
import { ContentId } from 'src/utils/constants/contentId';
import { Permission, SponsoredListingsCampaign } from 'src/WebApiController';

import { getTableColumnDefinitions } from './CampaignsTableV1ColumnsConfig';

export type CampaignsTableV1Props = {
  isLoading: boolean;
  disabled?: boolean;
  campaigns: SponsoredListingsCampaign[] | null | undefined;
  onStartWork: () => void;
  onStopWork: (success: boolean) => void;
};

export const CampaignsTableV1: React.FC<CampaignsTableV1Props> = ({
  isLoading,
  disabled,
  campaigns,
  onStartWork,
  onStopWork,
}) => {
  const hasAdPlatformViewPermission = useUserHasAnyOfPermissions(
    Permission.AdPlatform_CampaignsViewAll
  );

  if (!hasAdPlatformViewPermission) {
    return null;
  }

  if (isLoading) {
    return <PosSpinner />;
  }

  return campaigns?.length ? (
    <ColumnResizingContextProvider>
      <Table<SponsoredListingsCampaign>
        useVirtuoso
        actionColId={'actions'}
        data={campaigns ?? []}
        columns={getTableColumnDefinitions(onStartWork, onStopWork, disabled)}
        getRowId={(data, index) => String(data?.campaignId ?? index)}
        getItemId={(data) => String(data?.campaignId)}
        state={{
          sorting: [{ id: 'startDate', desc: false }],
        }}
      />
    </ColumnResizingContextProvider>
  ) : (
    <NoData style={{ border: `1px solid ${vars.color.borderPrimary}` }}>
      <Content id={ContentId.None} />
    </NoData>
  );
};
